import { type GridElement } from '..';
import { updateElement } from '../../../lib/element';
import { useEditorStore } from '../../../stores/useEditorStore';
import { ensureLoadedImage } from '../../../utils/image';

const TEST_STRUCTURE_TILE_RESOLUTION = 512;

let cachedTestTextureUrl: string | undefined;

export const getBaseTestTextureUrl = (): string => {
  if (cachedTestTextureUrl) return cachedTestTextureUrl;

  const canvas = document.createElement('canvas');

  canvas.width = TEST_STRUCTURE_TILE_RESOLUTION;
  canvas.height = TEST_STRUCTURE_TILE_RESOLUTION;

  const context = canvas.getContext('2d');

  if (context) {
    const halfSize = TEST_STRUCTURE_TILE_RESOLUTION / 2;

    context.fillStyle = '#ffffff';
    context.fillRect(
      0,
      0,
      TEST_STRUCTURE_TILE_RESOLUTION,
      TEST_STRUCTURE_TILE_RESOLUTION,
    );
    context.fillStyle = '#000000';
    context.fillRect(0, 0, halfSize, halfSize);
    context.fillRect(halfSize, halfSize, halfSize, halfSize);
  }

  cachedTestTextureUrl = canvas.toDataURL();

  return cachedTestTextureUrl;
};

export const getBaseTestTexture = (): Promise<HTMLImageElement> =>
  ensureLoadedImage(getBaseTestTextureUrl());

export const setScaledTestTexture = async (elementId: string) => {
  const element = useEditorStore.getState().elements.get(elementId) as
    | GridElement
    | undefined;
  if (!element || element.type !== 'grid') return;

  const baseTexture = await getBaseTestTexture();

  updateElement(
    useEditorStore.getState().elements,
    element,
    {
      calculatedTestStructure: baseTexture,
    },
    true,
  );
};
